export enum ImportDetailsDialogAction {
  Cancel = 'cancel',
  DownloadImportReport = 'download_report',
  DownloadConflictReport = 'download_conflict_report',
  Rerun = 'rerun',
}

export interface SelectStorageDialogData {
  projectId: string
}

